import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CreateSupportTicketModalComponent } from 'src/app/modals/create-support-ticket-modal/create-support-ticket-modal.component';

@Component({
  selector: 'app-error-banner',
  templateUrl: './error-banner.component.html',
  styleUrls: ['./error-banner.component.scss'],
  standalone: false,
})
export class ErrorBannerComponent {

  @Input() errorMessage: string | null = null;
  @Input() errorCode: string | null = null;
  @Input() logId: string | null = null;
  @Output() clearError = new EventEmitter<void>();


  constructor(private modalController: ModalController) {}

  createSupportTicket() {
    if (this.logId) {
      this.openCreateTicketModal(this.logId);
    }
    else {
      this.openCreateTicketModal(null);
    }
  }


  async openCreateTicketModal(logId: string) {
    const modal = await this.modalController.create({
      component: CreateSupportTicketModalComponent,
      componentProps: { abstract: this.errorMessage, logId },
    });

    modal.onDidDismiss().then((data) => {
      if (data?.data?.ticket) {
        console.log('Ticket created:', data.data.ticket);
        if (data?.data?.clearError) {
          this.clearError.emit(); // Clear the error message in the banner
        }
      }
    });

    await modal.present();
  }  


    // Ensures errorMessage ends with punctuation
    get formattedErrorMessage(): string {
      if (!this.errorMessage) return '';
      const trimmedMessage = this.errorMessage.trim();
      const lastChar = trimmedMessage.slice(-1);
      const punctuation = ['.', '!', '?'];
      return punctuation.includes(lastChar) ? trimmedMessage : `${trimmedMessage}.`;
    }

  dismissError() {
    this.clearError.emit(); // Notify parent to clear the error
  }

}
